import React, { useState } from "react";

//Components
import SocialAuthentication from "@Components/SocialLogin/components/SocialAuthentication";
import { useIntl } from "react-intl";
import HeaderBasic from "../../components/HeaderBasic";
import SignIn from "../../overrides/venia-ui/components/SignIn/signIn";
import signinImg from "@Assets/images/login/signIn.png";
//Style
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import defaultClasses from "./login.module.scss";
import { bgImage, handleDisabledButtonClick } from "@Src_main/utils/generalUtils";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
import Button from "@overrides_venia/venia-ui/components/Button";
import { useHistory } from "@magento/venia-ui/lib/drivers";
var Login = props => {
  var classes = mergeClasses(defaultClasses, props.classes);
  var {
    disablePreLogin,
    backFunction,
    skippable,
    returnUrl,
    isLandingPage = false,
    isOffCanvas = false
  } = props;
  var {
    isMobile
  } = useWindowSize();
  var history = useHistory();
  var [loginStep, setLoginStep] = useState('email');
  var {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React.createElement("div", {
    className: "login-page uk-flex  uk-background-cream ".concat(classes.root)
  }, isMobile ? /*#__PURE__*/React.createElement(HeaderBasic, {
    color: "black",
    title: formatMessage({
      id: "header.login.accedi"
    }),
    backFunction: isLandingPage ? null : backFunction,
    path: "close"
  }) : null, !isOffCanvas && !isMobile ? /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-flex-center uk-width-1-2 uk-background uk-background-cover",
    style: {
      backgroundImage: bgImage(signinImg)
    }
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(isMobile ? "" : isOffCanvas ? "uk-padding" : "uk-padding-large", " page_wrapper ").concat(classes.page_wrapper, " ").concat(isOffCanvas || isMobile ? "uk-width-1-1" : "uk-width-1-2")
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-container ".concat(classes.login_container)
  }, loginStep !== 'otp' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h1", {
    className: "".concat(classes.title, " uk-text-uppercase uk-text-center")
  }, formatMessage({
    id: "signin.title"
  })), /*#__PURE__*/React.createElement("p", {
    className: "".concat(classes.subtitle, " uk-text-center")
  }, formatMessage({
    id: "signin.subtitle"
  })), /*#__PURE__*/React.createElement(SocialAuthentication, {
    mode: "below_login",
    isPopup: false,
    showCreateAccount: () => {},
    bottomSeparator: true,
    textSeparator: formatMessage({
      id: "book.table.form.continue"
    })
  })), /*#__PURE__*/React.createElement(SignIn, {
    disablePreLogin: disablePreLogin,
    onStepChange: setLoginStep
  }))), isMobile ? /*#__PURE__*/React.createElement("div", {
    className: "uk-padding-large-bottom"
  }) : null);
};
export default Login;